import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LayoutService } from '@app/layout/layout.service';

@Component({
  selector: 'app-list-submit-success',
  templateUrl: './list-submit-success.component.html',
  styleUrls: ['./list-submit-success.component.less'],
})
export class ListSubmitSuccessComponent implements OnInit {
  DocNum: string;
  DocType: string;
  documentTitle: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.DocNum = params.docNum;
      this.DocType = params.docType;
      this.documentTitle = this.getDocumentTypeName(this.DocType); //params.documentTitle;
    });
  }

  goToShoppingList() {
    this.router.navigate([
      `/apps/external-portal/app-container/10/shopping-list/14/10331`,
    ]);
  }

  getDocumentTypeName(docType: string): string {
    let result = '';
    if (docType == '17') {
      result = this.layoutService.translate('Sales Order');
    }
    if (docType == '13') {
      result = this.layoutService.translate('Invoice');
    }
    if (docType == '23') {
      result = this.layoutService.translate('Sales Quotation');
    }

    return result;
  }
}
